import Button from '../Button/Button';

type ApplyButtonProps<T> = {
    setSelectedItems: (item: T[]) => void;
    setSelectedApplyItems: (item: T[]) => void;
    setOpen: (open: boolean) => void;
    selectedApplyItems: T[];
    onSelect: (item: T[]) => void;
};

export default function ApplyButton<T>({
    setSelectedItems,
    setSelectedApplyItems,
    setOpen,
    selectedApplyItems,
    onSelect,
}: ApplyButtonProps<T>) {
    return (
        <div className="py-2 alli-flex alli-h-[3.25rem] alli-items-center alli-justify-between alli-border-t alli-border-gray-400 alli-px-3">
            <Button
                className="alli-self-center"
                onClick={() => {
                    setSelectedApplyItems([]);
                    setSelectedItems([]);
                    onSelect([]);
                }}
                variant="text">
                Clear All
            </Button>
            <div className="alli-flex alli-gap-3">
                <Button
                    onClick={() => {
                        setOpen(false);
                    }}
                    variant="tertiary">
                    Cancel
                </Button>
                <Button
                    onClick={() => {
                        setSelectedItems(selectedApplyItems);
                        onSelect(selectedApplyItems);
                        setOpen(false);
                    }}>
                    Apply
                </Button>
            </div>
        </div>
    );
}
